export const environment = {
    baseUrl: 'https://api.lumia.voxa.cl/api'
};
